import { ReactNode, useEffect, useRef } from 'react';
import styles from './FullscreenContainer.module.scss';

type IProps = {
  fullWidth?: boolean;
  children: ReactNode;
};

export const FullscreenContainer = ({ fullWidth, children }: IProps): JSX.Element => {
  const scrollPositionRef = useRef<number>(0);
  // disable scrolling on body while this container is visible, remember and restore scroll position
  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    scrollPositionRef.current = window.scrollY;
    return () => {
      document.body.style.overflowY = '';
      window.scrollTo({ top: scrollPositionRef.current, left: 0, behavior: 'instant' });
    };
  }, []);
  
  return (
    <div className={styles.fullscreenContainerWrapper}>
      {fullWidth ? children : <div className={styles.fullscreenContainer}>{children}</div>}
    </div>
  );
};
